import { FeedbackLog } from '../types/feedback';

const MAX_LOGS = 50;
const logBuffer: FeedbackLog[] = [];

const originalConsole = {
  log: console.log,
  warn: console.warn,
  error: console.error,
  info: console.info,
};

function pushLog(level: FeedbackLog['level'], message: string, ...args: any[]) {
  const logEntry: FeedbackLog = {
    level,
    message: String(message),
    timestamp: new Date().toISOString(),
    data: args.map(arg => {
        try {
            return typeof arg === 'object' ? JSON.parse(JSON.stringify(arg)) : arg;
        } catch (e) {
            return '[Circular/Unserializable]';
        }
    }).slice(0, 3) // Limit to first 3 args to save space
  };

  logBuffer.push(logEntry);
  if (logBuffer.length > MAX_LOGS) {
    logBuffer.shift();
  }
}

export const logger = {
  init: () => {
    if (typeof window === 'undefined') return;

    // Prevent multiple initializations
    if ((console.log as any).__isLoggerWrapped) return;

    console.log = (message?: any, ...optionalParams: any[]) => {
      originalConsole.log(message, ...optionalParams);
      pushLog('log', message, ...optionalParams);
    };
    (console.log as any).__isLoggerWrapped = true;

    console.warn = (message?: any, ...optionalParams: any[]) => {
      originalConsole.warn(message, ...optionalParams);
      pushLog('warn', message, ...optionalParams);
    };

    console.error = (message?: any, ...optionalParams: any[]) => {
      originalConsole.error(message, ...optionalParams);
      pushLog('error', message, ...optionalParams);
    };
    
    console.info = (message?: any, ...optionalParams: any[]) => {
        originalConsole.info(message, ...optionalParams);
        pushLog('info', message, ...optionalParams);
    };
  },

  getLogs: () => [...logBuffer],
  
  clearLogs: () => {
      logBuffer.length = 0;
  }
};
